import React from "react";
import Slider from "react-slick";

const Testimonials = () => {
  const settings = {
    infinite: true,
    dots: true,
    speed: 500,
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToScroll: 1,
  };
  return (
    <section className="testimonial__wrapper ">
      <div className="testimonial__content w-80">
        <h2 className="mb-4">Our Students Voice</h2>

        <Slider {...settings}>
          <div>
            <div className="single__testimonial">
              <h3 className="mb-3 fw-bold">Murtaza Mehmood</h3>
              <p>
                It was a pleasure to have Hamza Sir as my online teacher from
                2021 to 2023. He made it very easy for me to learn and
                understand front-end development. He would always put in
                relentless efforts to make me understand the subject and
                succeed. I can surely say it was an honor to have you as my
                online teacher and your guidance was always there for me
                whenever I needed it. I want to thank you from the bottom of my
                heart for being an excellent teacher and mentor. I will forever
                be grateful to you sir.
              </p>

              <div className="student__info mt-4">
                <h4 className="fw-bold">Noroff University</h4>
                <h5>Oslo, Norway</h5>
              </div>
            </div>
          </div>

          <div>
            <div className="single__testimonial">
              <h3 className="mb-3 fw-bold">Shabnam Iftikhar</h3>
              <p>
                I highly recommend Mr. Hamza Khalid Bhutta as an online computer
                teacher for programming. His teaching skills are truly
                exceptional and have greatly influenced my learning journey. Sir
                Hamza’s ability to explain complex programming concepts in a
                simple and engaging manner is commendable. He goes above and
                beyond to provide comprehensive examples and real-world
                scenarios that enhance our understanding. Additionally, his
                patience and willingness to answer questions create a supportive
                learning environment. His dedication to helping his students
                succeed is evident in his prompt feedback and availability for
                assistance. I am grateful for his expertise and guidance, which
                have contributed significantly to my growth as a programmer.
              </p>

              <div className="student__info mt-4">
                <h4 className="fw-bold">Høyskolen Kristiania</h4>
                <h5>Oslo, Norway</h5>
              </div>
            </div>
          </div>
        </Slider>
      </div>
    </section>
  );
};

export default Testimonials;
